import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import PermissionsResponse from '../../types/response/PermissionsResponse'

export type PermissionLight = {
  id: string
}

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPermissions: builder.query<PermissionsResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'permissions',
        params: props,
      }),
      providesTags: () => [{ type: 'Permission', id: 'LIST' }],
    }),
  }),
})

export const { useGetPermissionsQuery } = extendedApiSlice
